const STORAGE_PREFIX = 'guidedTourPreferences:';

export type GuidedToursMap = {
  [tourId: string]: { [variant: string]: boolean | undefined };
};

export const getGuidedTourStorageKey = (userId: string): string =>
  `${STORAGE_PREFIX}${userId}`;

export const readGuidedToursFromStorage = (userId: string): GuidedToursMap => {
  try {
    const raw = window.localStorage.getItem(getGuidedTourStorageKey(userId));
    return raw ? (JSON.parse(raw) as GuidedToursMap) : {};
  } catch {
    return {};
  }
};

export const writeGuidedToursToStorage = (
  userId: string,
  tours: GuidedToursMap
): void => {
  try {
    window.localStorage.setItem(
      getGuidedTourStorageKey(userId),
      JSON.stringify(tours)
    );
  } catch {
    // Ignore localStorage errors
  }
};

export const mergeGuidedTours = (
  local: GuidedToursMap,
  remote: GuidedToursMap
): GuidedToursMap => {
  const merged: GuidedToursMap = { ...local };

  Object.entries(remote).forEach(([tourId, variants]) => {
    const nextVariants = { ...(merged[tourId] || {}) };
    Object.entries(variants || {}).forEach(([variant, completed]) => {
      if (completed) {
        nextVariants[variant] = true;
      }
    });
    if (Object.keys(nextVariants).length) {
      merged[tourId] = nextVariants;
    }
  });

  return merged;
};

export const isGuidedTourCompleted = (
  tours: GuidedToursMap,
  tourId: string,
  variant: string
): boolean => Boolean(tours?.[tourId]?.[variant]);

export const markGuidedTourCompletedInMap = (
  tours: GuidedToursMap,
  tourId: string,
  variant: string
): GuidedToursMap => ({
  ...tours,
  [tourId]: {
    ...(tours[tourId] || {}),
    [variant]: true,
  },
});
